import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Hero from 'components/Hero';
import SecondaryStory from 'components/SecondaryStory';
import { format } from 'date-fns';
import QuillEditor from 'components/QuillEditor';

const styles = theme => ({});

const Preview = props => {
  const { values } = props;
  const lastUpdated = new Date();
  return (
    <Fragment>
      <Hero
        {...{
          title: values.title,
          lastUpdated: format(lastUpdated, 'MMM DD YYYY'),
          imageUrl:
            values.featuredImage.uri ||
            URL.createObjectURL(values.featuredImage.file),
          oneLiner: values.summary,
        }}
      />
      <SecondaryStory
        {...{
          cities: values.cities.map(({ label }) => label),
          dishesTags: values.dishes.map(({ label }) => label),
          eateriesTags: values.eateries.map(({ label }) => label),
          cuisinesTags: values.cuisines.map(({ label }) => ({ name: label })),
          location: {
            locality: values.locality ? values.locality : '',
          },
          history: null,
        }}
      />
      <QuillEditor
        value={values.content}
        readOnly={true}
      />
      {/*<div className="ql-container ql-snow">
        <div
          className="ql-editor"
          dangerouslySetInnerHTML={{ __html: values.content }}
        />
      </div>*/}
    </Fragment>
  );
};

export default withStyles(styles)(Preview);
